<template>
	<div class="opportunities-subview">
		<div class="subviewOpts">
			<it-link :to="createOpportunityLink" class="button-link button-link-bicon"><sym-icon name="opportunity"></sym-icon> {{ env.msg('menu.addOpportunity') }}</it-link>
		</div>
		<div id="opportunitiesSubview">
			<crm-table :rest-api="restApi"></crm-table>
		</div>
	</div>
</template>

<script setup lang="ts">
import {ref, computed} from "vue";
import {injectEnv} from "@fd/Environment.ts";
import {addContextParams, ContextKey, getIntValue, injectContext, OPPORTUNITY_REFS} from "@t/fd/AppContext.ts";
import CrmTable from "@/vue/table/CrmTable.vue";
import ItLink from "@/router/ItLink.vue";
import SymIcon from "@fd/helpers/SymIcon.vue";

const env = injectEnv();
const ctx = injectContext();
const sourceType = computed<number>(() => getIntValue(ctx.value, ContextKey.SRC_TYPE));
const sourceId = computed<string|number>(() => getIntValue(ctx.value, ContextKey.SRC_ID));

const restApi = computed<string>(() => {
	let ep = "api/opportunities/agendaSubview";
	ep = env.net.urlParam(ep, "srcType", sourceType.value);
	ep = env.net.urlParam(ep, "srcId", sourceId.value);
	return ep;
});

const createOpportunityLink = computed<string>(() => {
	let link = addContextParams('createOpportunity.do', ctx.value, OPPORTUNITY_REFS);
	return link;
});
</script>

<style>

</style>